// src/pages/PazYSalvo.jsx
import React from 'react';
import PazYSalvoManager from '../components/PazYSalvoManager';

export default function PazYSalvo() {
    return (
        <div className="p-6">
            <PazYSalvoManager />
        </div>
    );
}
